import mailStore from '../store/Store';
import { action } from 'satcheljs/lib/legacy';

/**
 * Deletes all conversation info from mail store;
 * Used primarily by conversationCache to remove excess entries
 */
const deleteConversationItemParts = action('deleteConversationItemParts')(
    function deleteConversationItemParts(conversationId: string) {
        if (mailStore.conversations.has(conversationId)) {
            const conversationItemParts = mailStore.conversations.get(conversationId);
            for (const conversationNodeId of conversationItemParts.conversationNodeIds) {
                const conversationNode = mailStore.conversationNodes.get(conversationNodeId);
                for (const itemId of conversationNode.itemIds) {
                    mailStore.items.delete(itemId);
                }
                mailStore.conversationNodes.delete(conversationNodeId);
            }

            mailStore.conversations.delete(conversationId);
        }
    }
);

export default deleteConversationItemParts;
